import { type ReactNode } from 'react';

interface CardChromeProps {
  children: ReactNode;
}

/**
 * Shared centered-card chrome for the four unauthenticated external pages
 * (login, forgot-password, reset-password, accept-invite).
 *
 * Layout per UI-SPEC §"Shared auth-card chrome": gray-50 background,
 * centered white card (max-w-sm), Monksheets brand at top, "External access"
 * subtitle so external users can verify they're on the right surface and
 * we can be told apart from the internal /login page at a glance.
 */
export function CardChrome({ children }: CardChromeProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-lg bg-white p-8 shadow-lg">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-semibold text-primary-600">Monksheets</h1>
            <p className="mt-2 text-gray-500">External access</p>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
